import { render, staticRenderFns } from "./ReviewDocumentsComponent.vue?vue&type=template&id=150a452f&scoped=true&"
import script from "./ReviewDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewDocumentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150a452f",
  null
  
)

export default component.exports